import loadable from '@loadable/component'

const Index = loadable(() => import('../pages/index'));
const Home = loadable(() => import('../pages/home'));
const ClassList = loadable(() => import('../pages/classlist'));
const Care = loadable(() => import('../pages/care'));


export const routerConfig = [
  {
    name: '',
    path: '/',
    redirect: '/home',
    Component: Index,
    children:[
      {
          name: '首页',
          path:'/home',
          Component: Home,
          children:[]
      },
      {
          name: '班级成员',
          path:'/class',
          Component: ClassList,
          children:[]
      },
      {
          name: '照顾餐',
          path:'/care',
          Component: Care,
          children:[]
      },
     ]
  }
]
